// src/components/About.js
import React, { useEffect } from 'react';
import '../css/About.css'; // Link to the new CSS file

// Import images from your assets folder
// Ensure these paths are correct based on your project structure
import AboutBannerImage from '../assets/hotel4.avif'; // Using hotel4.avif for a general banner
import FeatureImage1 from '../assets/gallery/Hall1.jpeg'; // Example feature image
import FeatureImage2 from '../assets/hotel3.webp'; // Example feature image
import FounderImage from '../assets/owner_photo.jpeg'; // Assuming you have an owner photo here

export default function About() {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrapper">
      {/* Hero Banner for About Page */}
      <div className="about-banner" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${AboutBannerImage})` }}>
        <h1>About Us</h1>
        <p>Your Trusted Partner for Girls' PG Stays</p>
      </div>

      {/* Our Story Section */}
      <section className="about-section story-section">
        <div className="section-content">
          <h2>Our Story & Mission</h2>
          <p>
            At <b>No Brokerage Paying Guest</b>, our story is born from a genuine understanding of the challenges young women face when moving to a dynamic city like Mumbai. We know that finding a safe, comfortable, and genuinely affordable living space is often overshadowed by the stress of dealing with brokers and exorbitant fees.
          </p>
          {/* <h5><b>Our Powerful Mission: Zero Brokerage, Maximum Comfort</b></h5>
          <p>Our journey began with a simple yet powerful mission: to eliminate the hassle of brokerage fees and provide a seamless, trustworthy platform for finding premium Girls' PG and co-living accommodations.</p> */}
          <p>In a city where rental agreements can often lead to disputes over hidden charges and hefty security deposits, our No Brokerage model offers immediate financial relief and transparency. We are committed to making your transition to Malad, Goregoan and Kandivali — a prime hub for students and working professionals—as smooth and stress-free as possible.</p>
          <p><b>We believe that a living space is more than just a room; it's a foundation for growth, learning, and building connections.</b></p>
        </div>
        <div className="section-image">
          <img src={FeatureImage1} alt="Our Story" />
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="about-section choose-us-section">
        <div className="section-image">
          <img src={FeatureImage2} alt="Why Choose Us" />
        </div>
        <div className="section-content">
          <h2>Why Choose No Brokerage Paying Guest?</h2>
          <ul className="why-choose-list">
            <li>
              <strong>Zero Brokerage:</strong> Say goodbye to hefty commission fees. We connect you directly with property owners, saving you thousands on your accommodation cost.
            </li>
            <li>
              <strong>Safety First:</strong> All our listed PGs undergo rigorous background checks and are equipped with robust security measures, ensuring a safe and secure environment for every resident, 24/7.
            </li>
            <li>
              <strong>Comfort & Convenience:</strong> We ensure all your daily needs are met. This includes:Fully furnished rooms , High-speed Wi-Fi, Delicious, hygienic meals ,Laundry services
            </li>
            <li>
              <strong>Vibrant Community:</strong> Live among like-minded individuals. Our PGs foster a friendly atmosphere where you can make new friends, network, and build lasting memories in a supportive co-living environment.
            </li>
            <li>
              <strong>Prime Locations:</strong> We offer properties in well-connected and secure neighborhoods, close to educational institutions, workplaces, and essential services in Malad, Goregoan and Kandivali and across Mumbai.
            </li>
          </ul>
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="about-section vision-section">
        <div className="section-content text-center-content">
          <h2>Our Vision for the Future: <b>The Best PG in Mumbai</b></h2>
          <p>
            We envision a future where every young woman has easy access to a <b>secure, comfortable, and empowering living space</b>, completely free from financial burdens and the logistical headaches of traditional renting.Our goal is not just to offer accommodation, but to set the standard: to make <b>high-quality, brokerage-free co-living the standard, not the exception, in Mumbai</b>. We continuously strive to expand our network, enhance our services, and innovate to meet the evolving needs of our residents, positioning <b>No Brokerage Paying Guest</b> as the definitive <b>best girl PG in Mumbai</b>.
          </p>
          <a href="/contact" className="cta-button">Connect With Us</a>
        </div>
      </section>

      {/* Meet Our Founder Section */}
      <section className="about-section founder-section">
        <div className="section-image">
          <img src={FounderImage} alt="Founder" className="founder-photo" />
          <span className="founder-name">Sweta Rita</span>
          <p className="founder-title"><strong>Owner & Founder</strong></p>
        </div>
        <div className="section-content">
          <h3>Meet Our Founder</h3>
          <p>
            <b>Sweta Rita</b> founded <b>No Brokerage Paying Guest</b> with a deep understanding of the challenges students and working professionals face in urban accommodation. With over a decade of experience in providing premium accommodation services, Sweta Rita envisioned a platform that prioritizes: Transparency (No Brokerage) ,Safety (Secure Premises) ,Community (Supportive Environment) ,Affordability .She is dedicated to building a trusted network of premium PGs and fostering a supportive environment for young women across Mumbai.Our founder's commitment to excellence and resident satisfaction drives our continuous efforts to provide the best possible service and ensure a seamless and affordable living experience for all residents.
          </p>
        </div>
      </section>

      {/* Testimonials Section (Optional - can be expanded if you have real testimonials) */}
      <section className="about-testimonials-section"> {/* Changed class name */}
        <h2>What Our Residents Say</h2>
        <div className="about-testimonials-grid"> {/* Changed class name */}
          <div className="about-testimonial-card"> {/* Changed class name */}
            <p>"Finding a PG without brokerage was a dream come true! The facilities are excellent, and I feel very safe here."</p>
            <p className="about-testimonial-author">- Priya S., Mumbai</p> {/* Changed class name */}
          </div>
          <div className="about-testimonial-card"> {/* Changed class name */}
            <p>"The community here is amazing. I've made so many new friends, and the staff is incredibly supportive."</p>
            <p className="about-testimonial-author">- Aisha K., Mumbai</p> {/* Changed class name */}
          </div>
          <div className="about-testimonial-card"> {/* Changed class name */}
            <p>"Clean rooms, good food, and no hidden charges. No Brokerage Paying Guest made my move so easy!"</p>
            <p className="about-testimonial-author">- Sneha R., Mumbai</p> {/* Changed class name */}
          </div>
        </div>
      </section>
    </div>
  );
}